import {Theme} from '@mui/material/styles';

export default function DialogAction(theme: Theme) {
  return {
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '0 32px 32px 32px',
          [theme.breakpoints.down('sm')]: {
            padding: '0 16px 32px 16px',
          },
        },
      },
    },
  };
}
